import { PostJourneysGetJourneyResponseDataTravelersInnerFrequentFlyerCardsInner } from 'src/sdk_checkin';

/**
 * マイレージプログラム情報の一部のフィールドで入力有を判定する
 * @returns true 入力有り / false 入力無し
 */
export function isEnteredFrequentFlyerCard(
  frequentFlyerCard?: PostJourneysGetJourneyResponseDataTravelersInnerFrequentFlyerCardsInner
): boolean {
  let isEntered = false;

  if (frequentFlyerCard?.companyCode || frequentFlyerCard?.cardNumber) {
    isEntered = true;
  }

  return isEntered;
}

/**
 * マイレージプログラム情報配列で全てのフィールドで入力有かを判定する
 * @returns true 入力有り / false 入力無し
 */
export function isRegisteredFrequentFlyerCard(
  frequentFlyerCards?: PostJourneysGetJourneyResponseDataTravelersInnerFrequentFlyerCardsInner[]
): boolean {
  let isRegistered = false;

  if (frequentFlyerCards && frequentFlyerCards.length > 0) {
    if (frequentFlyerCards.length === 1) {
      // 単一レコードはミドルネームを除く全ての入力項目が存在する場合に登録済み
      const frequentFlyerCard = frequentFlyerCards[0];

      if (frequentFlyerCard.companyCode && frequentFlyerCard.cardNumber) {
        isRegistered = true;
      }
    } else {
      // 複数レコードの場合は登録済み
      isRegistered = true;
    }
  }

  return isRegistered;
}

/**
 * マイレージプログラム情報配列で全てのフィールドで入力無が存在するかを判定する
 * @returns true 入力無し / false 入力有り
 */
export function isNotEnteredFrequentFlyerCardAll(
  frequentFlyerCards?: PostJourneysGetJourneyResponseDataTravelersInnerFrequentFlyerCardsInner[]
): boolean {
  // マイレージプログラム情報配列が存在しない場合、入力なし
  if (!frequentFlyerCards) {
    return true;
  }

  // 全てのマイレージプログラムが未入力である場合true、1つでも入力があればfalse
  return frequentFlyerCards.every((frequentFlyerCard) => !isEnteredFrequentFlyerCard(frequentFlyerCard));
}
